import { Group, NumberInput, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LineRange = ({
  lines,
  setLines,
  headerLine,
  setHeaderLine,
  handleUpdate,
}) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack gap={"xs"}>
      <Text>{lang.files.import_line_text}</Text>
      <Group w={"90%"} align="end">
        <NumberInput
          label={lang.files.header_line}
          value={headerLine}
          min={1}
          onChange={setHeaderLine}
          onBlur={(e) => {
            let newValue = parseInt(e.target.value);
            handleUpdate({ defaultHeaderLine: newValue });
          }}
          flex={1}
        />
        <NumberInput
          label={lang.files.line_start}
          value={lines[0]}
          min={0}
          onChange={(v) => {
            let newLines = [v, lines[1]];
            setLines(newLines);
          }}
          onBlur={(e) => {
            let newValue = parseInt(e.target.value);
            let newLineStart =
              lines[1] === 0
                ? newValue
                : newValue > lines[1]
                ? lines[1]
                : newValue;
            let newLines = [newLineStart, lines[1]];
            setLines(newLines);
            handleUpdate({ defaultLines: newLines });
          }}
          flex={1}
        />
        <NumberInput
          label={`${lang.files.line_end} ( 0 pour le reste )`}
          value={lines[1]}
          onChange={(v) => {
            let newLines = [lines[0], v];
            setLines(newLines);
          }}
          onBlur={(e) => {
            let newValue = parseInt(e.target.value);
            let newLineEnd =
              newValue === 0 ? 0 : newValue < lines[0] ? lines[0] : newValue;
            let newLines = [lines[0], newLineEnd];
            setLines(newLines);
            handleUpdate({ defaultLines: newLines });
          }}
          flex={1}
        />
      </Group>
    </Stack>
  );
};

export default LineRange;
